import { render, staticRenderFns } from "./PlaceModal.vue?vue&type=template&id=1603c8ba&scoped=true"
import script from "./PlaceModal.vue?vue&type=script&lang=js"
export * from "./PlaceModal.vue?vue&type=script&lang=js"
import style0 from "./PlaceModal.vue?vue&type=style&index=0&id=1603c8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603c8ba",
  null
  
)

export default component.exports